import { MatDialogRef } from '@angular/material/dialog';
import { ActionHelper } from '../../../helper/action.helper';
import { AppFrameComponent } from '../../page-modules/app-frame/app-frame.component';
import { BaseDialog } from './base-dialog';

export class BaseCustomDialog extends BaseDialog {

  constructor(
    dialogRef: MatDialogRef<any>
  ) {
    super(dialogRef);
    dialogRef.afterOpened().subscribe(_ => {
      dialogRef.addPanelClass('modal-opened');
      ActionHelper.initializeOrResetUnsavedChanges(this);
    });
  }

  clearClassAndCloseDialog(dialogRef: MatDialogRef<any>, message?: string|boolean): Promise<void> {
    return new Promise(resolve => {
      const onClose = () => {
        ActionHelper.clearUnsavedChanges(this);
        dialogRef.addPanelClass('modal-close');

        setTimeout(_ => {
          dialogRef.close(message)
          resolve();
        }, 320);
      }

      if (!message && ActionHelper.hasUnsavedChanges(this)) {
        AppFrameComponent.warnAboutUnsavedChanges((confirmed) => {
          if (confirmed) {
            onClose();
          }
        });
      } else {
        onClose();
      }
    })
  }

}
